// Angular
import { Component, HostListener, isDevMode, OnInit } from '@angular/core';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';

// RXJS
import { filter } from 'rxjs';

// PrimeNG
import { MessageService } from 'primeng/api';

// Services
import { CheckForUpdateService } from './service/ServiceWorker/check-for-update.service';
import { HandleUnrecoverableStateService } from './service/ServiceWorker/handle-unrecoverable-state.service';
import { LocalStorageManagerService } from './service/localStorageManager/localStorageManager.service';
import { LogUpdateService } from './service/ServiceWorker/log-update.service';
import { AppConfigService } from './service/app-config.service';
import { ThemeManagerService } from './service/theme-manager.service';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  standalone: false,
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {

  public serverUrl = environment.serverUrl;

  public appName = environment.appName;

  public applicationType = environment.features.applicationType;

  public networkStatus = false;

  constructor(
        private readonly updates: SwUpdate,
        _log: LogUpdateService,
        _check: CheckForUpdateService,
        _handle: HandleUnrecoverableStateService,
        _localStorageManager: LocalStorageManagerService,
        private readonly messageService: MessageService,
        private readonly appConfig: AppConfigService,
        private readonly themeManager: ThemeManagerService,
  ) {
    this.themeManager.configureTheme();
    this.appConfig.configureApp();
  }

    @HostListener('window:offline', ['$event'])
  offlineEvent(event: { type: string }): void {
    console.log(event);
    this.notifyOffline();
  }

    @HostListener('window:online', ['$event'])
    onlineEvent(event: { type: string }): void {
      console.log(event);
      this.notifyOnline();
    }

    ngOnInit(): void {
      this.handleAccessToAddonApps();
      this.handleServiceWorkerUpdates();
      this.showDevReminder();
    }
    
    /**
     *  Reload application and clear messages
     */ 
    reload(): void {
      location.reload();
      this.messageService.clear();
    }

    /**
     *  Notify the user when Internet connection is recovered
     */
    private notifyOnline(): void {
      this.messageService.add({
        severity: 'success',
        summary: 'Conexión a Internet Recuperada',
        detail: 'Refresca el navegador para ver los datos actuales.',
      });
    }


    /**
     *  Notify the user when offline
     */
    private notifyOffline(): void {
      this.messageService.add({
        severity: 'warn',
        summary: 'Sin Conexión a Internet',
        detail: 'Acabas de perder la conexión a Internet: los datos visibles son a los que tenias acceso antes de perder la conexión.',
      });
    }


    /**
     *  Redirect to trailing slash in order to prevent the browser from redirecting to dashboard
     */
    private handleAccessToAddonApps(): void {
      if (window.location.pathname === '/visitas') {
        window.location.replace('/visitas/');
      }

      if (window.location.pathname === '/fichajes') {
        window.location.replace('/fichajes/');
      }


      if (window.location.pathname === '/tratamientos_track') {
        window.location.replace('/tratamientos_track/');
      }
    }

    /**
     * Handle service worker update events
     */
    private handleServiceWorkerUpdates(): void {
      this.updates.versionUpdates
        .pipe(filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY'))
        .subscribe(() => {
          this.messageService.add({
            severity: 'secondary',
            summary: 'Nueva Versión Disponible',
            detail: 'Una nueva versión de la app se encuentra disponible: pulsa F5 para acceder a ella.',
          });
        });
    }


    /** 
     * Show a reminder when running in local dev mode
     */
    private showDevReminder(): void {
      const popupDelay = 500;

      setTimeout(() => {
        if (isDevMode()) {
          const favIcon: HTMLLinkElement = document.querySelector('#appIcon') ?? new HTMLLinkElement();
                
          favIcon.href = 'https://locatec.es/favicon.ico';
          this.messageService.add({
            severity: 'contrast',
            summary: 'Estás en Localhost',
            detail: 'Tu amigable recordatorio de que estás viendo los cambios que haces en local.',
          });
        }
      }, popupDelay);
    }
}
